export default "__VITE_ASSET__ac9BxkT5__"